import React, { Component } from 'react'
import butter from '../../elements/butterClient/butterClient.js'
import BlogCard from '../card/blogCard.js'
import { Header, Columns } from '../../elements'
class RelatedPosts extends Component {
  state = {
    data: {},
    hasData: false,
  }
  componentDidMount() {
    let category = this.props.category.slug || ''
    let butterParams = { page: 1, category_slug: category, page_size: 4, exclude_body: true }
    butter.post
      .list(butterParams)
      .then(
        function(resp) {
          //console.log(resp)
          this.setState(resp.data)
          this.setState({ hasData: resp.data.data.length > 1 ? true : false })
        }.bind(this),
      )
      .catch(
        function(resp) {
          //console.log(resp)
          //eslint-disable-next-line
        }.bind(this),
      )
  }
  render() {
    return (
      <React.Fragment>
        {this.state.hasData && (
          <div className={'related-posts-wrap ' + this.props.className}>
            <Header renderas="h2" className="has-text-weight-extra-bold is-size-4">
              Related Posts
            </Header>
            <Columns>
              {this.state.hasData &&
                this.state.data.map((post, key) => <BlogCard post={post} key={key} headerLevel={'h3'} />)}
            </Columns>
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default RelatedPosts
